import React from 'react';
import PropTypes from 'prop-types';

import styles from './upgradeToUtrCollege.scss';

const UpgradeToUtrCollegeButton = props => {
    const { onClick, small, clubStatus, 'data-testid': dataTestId } = props;

    const getCollegeButtonText = clubStatusObject => {
        switch (clubStatusObject.value) {
            case 'overdue':
            case 'revoked':
            case 'suspended':
                return 'Renew College Coach';
            case 'paymentrequired':
                return 'Activate College Coach';
            case 'pending':
                return 'Try College Coach';
            default:
                return 'Try College Coach';
        }
    };
    return (
        <button
            type="button"
            className={`btn btn-primary ${small ? 'btn-sm' : 'btn-lg'} text-uppercase ${styles.primaryActionButton}`}
            onClick={onClick}
            data-testid={dataTestId}
        >
            {getCollegeButtonText(clubStatus)}
        </button>
    );
};

UpgradeToUtrCollegeButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    small: PropTypes.bool,
    clubStatus: PropTypes.objectOf(PropTypes.any).isRequired,
};

UpgradeToUtrCollegeButton.defaultProps = {
    small: false,
};

export default UpgradeToUtrCollegeButton;
